(function(){
  'use strict';
  var ROOT = document.getElementById('merino-root');
  if(!ROOT) return;

  var RM = window.matchMedia('(prefers-reduced-motion: reduce)');
  var reduced = RM.matches;
  if(reduced) ROOT.classList.add('mr-no-motion');

  /* ---------- utilitaires ---------- */
  var clamp = function(v,a,b){ return v<a?a:(v>b?b:v); };
  var lerp  = function(a,b,t){ return a+(b-a)*t; };
  var raf   = window.requestAnimationFrame.bind(window);

  /* =========================================================
     1. SPLINE CUBIQUE NATURELLE — continuité C2
     Courbure continue aux ancres : le passage concave/convexe
     se fait sans cassure. (La méthode à points de contrôle
     alternés cassait de ~27° à chaque ancre.)
     ========================================================= */
  function thomas(a,b,c,d){
    var n=d.length, cp=new Float64Array(n), dp=new Float64Array(n), i, m;
    cp[0]=c[0]/b[0]; dp[0]=d[0]/b[0];
    for(i=1;i<n;i++){ m=b[i]-a[i]*cp[i-1]; cp[i]=c[i]/m; dp[i]=(d[i]-a[i]*dp[i-1])/m; }
    var x=new Float64Array(n); x[n-1]=dp[n-1];
    for(i=n-2;i>=0;i--) x[i]=dp[i]-cp[i]*x[i+1];
    return x;
  }
  function natural(t,y){
    var n=y.length,i,k;
    if(n<3){ var hh=t[1]-t[0]; return {b:[(y[1]-y[0])/hh],c:[0],d:[0]}; }
    var h=new Float64Array(n-1);
    for(i=0;i<n-1;i++) h[i]=t[i+1]-t[i];
    var m=new Float64Array(n), sz=n-2;
    if(sz>0){
      var a=new Float64Array(sz), bb=new Float64Array(sz), cc=new Float64Array(sz), dd=new Float64Array(sz);
      for(i=0;i<sz;i++){
        k=i+1;
        a[i]=h[k-1]; bb[i]=2*(h[k-1]+h[k]); cc[i]=h[k];
        dd[i]=6*((y[k+1]-y[k])/h[k]-(y[k]-y[k-1])/h[k-1]);
      }
      a[0]=0; cc[sz-1]=0;
      var sol=thomas(a,bb,cc,dd);
      for(i=0;i<sz;i++) m[i+1]=sol[i];
    }
    var b=new Float64Array(n-1), c=new Float64Array(n-1), d=new Float64Array(n-1);
    for(i=0;i<n-1;i++){
      b[i]=(y[i+1]-y[i])/h[i]-(h[i]*(2*m[i]+m[i+1]))/6;
      c[i]=m[i]/2;
      d[i]=(m[i+1]-m[i])/(6*h[i]);
    }
    return {b:b,c:c,d:d};
  }
  function splinePath(pts){
    var n=pts.length,i;
    if(n<2) return '';
    if(n===2) return 'M '+pts[0].x+' '+pts[0].y+' L '+pts[1].x+' '+pts[1].y;
    var t=new Float64Array(n);
    for(i=1;i<n;i++) t[i]=t[i-1]+Math.max(1e-6,Math.hypot(pts[i].x-pts[i-1].x, pts[i].y-pts[i-1].y));
    var xs=pts.map(function(p){return p.x;}), ys=pts.map(function(p){return p.y;});
    var sx=natural(t,xs), sy=natural(t,ys);
    var r=function(v){ return Math.round(v*100)/100; };
    var dstr='M '+r(xs[0])+' '+r(ys[0]);
    for(i=0;i<n-1;i++){
      var h=t[i+1]-t[i];
      dstr+=' C '+r(xs[i]+sx.b[i]*h/3)+' '+r(ys[i]+sy.b[i]*h/3)+', '
                 +r(xs[i]+2*sx.b[i]*h/3+sx.c[i]*h*h/3)+' '+r(ys[i]+2*sy.b[i]*h/3+sy.c[i]*h*h/3)+', '
                 +r(xs[i+1])+' '+r(ys[i+1]);
    }
    return dstr;
  }

  /* =========================================================
     2. TRACÉ AU SCROLL
     ========================================================= */
  var zone   = ROOT.querySelector('[data-thread-zone]');
  var svg    = ROOT.querySelector('[data-thread-svg]');
  var pGuide = ROOT.querySelector('[data-thread-guide]');
  var pDraw  = ROOT.querySelector('[data-thread-draw]');
  var pMask  = ROOT.querySelector('[data-thread-mask]');
  var head   = ROOT.querySelector('[data-thread-head]');
  var halo   = ROOT.querySelector('[data-thread-halo]');
  var len = 0, threadReady = false;

  function buildThread(){
    if(!zone||!svg||!pDraw) return;
    var anchors = zone.querySelectorAll('[data-anchor]');
    if(anchors.length < 2){ threadReady=false; return; }
    var zr = zone.getBoundingClientRect();
    var top = zr.top + window.pageYOffset;
    var w = zone.clientWidth, h = zone.offsetHeight;
    var pts = [], i;
    for(i=0;i<anchors.length;i++){
      var el = anchors[i];
      var r = el.getBoundingClientRect();
      var fx = parseFloat(el.getAttribute('data-anchor'));
      if(isNaN(fx)) fx = 0.5;
      pts.push({ x: w*fx, y: (r.top + window.pageYOffset) - top + r.height/2 });
    }
    /* Deux ancres trop proches verticalement forceraient un virage serré :
       on fusionne. */
    var keep = [pts[0]];
    for(i=1;i<pts.length;i++){
      if(pts[i].y - keep[keep.length-1].y < 90 && i < pts.length-1) continue;
      keep.push(pts[i]);
    }
    pts = keep;
    if(pts.length < 2){ threadReady=false; return; }

    /* Garde-fou anti-boucle : une excursion horizontale plus large que
       l'écart vertical produit un dépassement de spline (la courbe part
       en boucle). On borne la pente à 40° en ramenant x vers l'ancre
       précédente. Le tracé reste doux quelle que soit la mise en page. */
    for(i=1;i<pts.length;i++){
      var dy = pts[i].y - pts[i-1].y;
      var maxdx = Math.max(20, dy * 0.62);
      var dx = pts[i].x - pts[i-1].x;
      if(Math.abs(dx) > maxdx) pts[i].x = pts[i-1].x + (dx > 0 ? maxdx : -maxdx);
    }
    svg.setAttribute('viewBox','0 0 '+w+' '+h);
    svg.setAttribute('width', w); svg.setAttribute('height', h);
    var d = splinePath(pts);
    if(pGuide) pGuide.setAttribute('d', d);
    pDraw.setAttribute('d', d);
    if(pMask) pMask.setAttribute('d', d);
    len = pDraw.getTotalLength();
    var target = pMask || pDraw;
    target.style.strokeDasharray = len + ' ' + len;
    target.style.strokeDashoffset = len;
    threadReady = true;
  }

  var progT = 0, progC = 0;
  function threadProgress(){
    if(!zone) return 0;
    var r = zone.getBoundingClientRect();
    var vh = window.innerHeight;
    var span = r.height - vh * 0.35;
    if(span <= 0) return 1;
    return clamp((vh * 0.62 - r.top) / span, 0, 1);
  }
  function paintThread(p){
    if(!threadReady) return;
    var target = pMask || pDraw;
    target.style.strokeDashoffset = len * (1 - p);
    if(head && len){
      try{
        var pt = pDraw.getPointAtLength(len * p);
        head.setAttribute('cx', pt.x); head.setAttribute('cy', pt.y);
        head.style.opacity = (p > 0.002 && p < 0.999) ? 1 : 0;
        if(halo){ halo.setAttribute('cx', pt.x); halo.setAttribute('cy', pt.y); halo.style.opacity = head.style.opacity; }
      }catch(e){}
    }
  }

  /* =========================================================
     3. PROGRESSION GLOBALE LISSÉE (sensation d'inertie sans
        détourner le scroll natif — indispensable dans un thème
        Shopify, sinon le header sticky casse)
     ========================================================= */
  var barEl = ROOT.querySelector('[data-progress-bar]');
  var scaleEls = ROOT.querySelectorAll('[data-scale-readout]');
  var paraEls = ROOT.querySelectorAll('[data-para]');
  var tiltEls = ROOT.querySelectorAll('[data-tilt]');

  function tick(){
    progT = threadProgress();
    progC = reduced ? progT : lerp(progC, progT, 0.085);
    if(Math.abs(progC - progT) < 0.0002) progC = progT;
    paintThread(progC);
    if(barEl) barEl.style.transform = 'scaleX(' + progC + ')';

    /* parallaxe douce */
    var vh = window.innerHeight, i;
    for(i=0;i<paraEls.length;i++){
      var pe = paraEls[i], pr = pe.getBoundingClientRect();
      if(pr.bottom < -200 || pr.top > vh + 200) continue;
      var amt = parseFloat(pe.getAttribute('data-para')) || 0.08;
      var rel = (pr.top + pr.height/2 - vh/2) / vh;
      pe.style.transform = 'translate3d(0,' + (rel * amt * 100).toFixed(2) + 'px,0)';
    }
    ROOT.style.setProperty('--mr-progress', progC.toFixed(4));
    raf(tick);
  }

  /* =========================================================
     4. RÉVÉLATIONS
     ========================================================= */
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if(!en.isIntersecting) return;
      var el = en.target;
      el.classList.add('is-in');
      if(el.hasAttribute('data-count')) runCount(el);
      if(el.hasAttribute('data-decode')) runDecode(el);
      if(el.hasAttribute('data-bar')) el.style.setProperty('--bar', el.getAttribute('data-bar') + '%');
      io.unobserve(el);
    });
  }, { threshold: 0.18, rootMargin: '0px 0px -8% 0px' });

  var revealSel = '[data-reveal],[data-count],[data-decode],[data-bar],[data-draw-group]';
  var revealEls = ROOT.querySelectorAll(revealSel);
  for(var ri=0; ri<revealEls.length; ri++) io.observe(revealEls[ri]);

  /* lignes de titre : délai en cascade */
  var lineWraps = ROOT.querySelectorAll('[data-lines]');
  for(var li=0; li<lineWraps.length; li++){
    var kids = lineWraps[li].querySelectorAll('.mr-line > span');
    for(var kj=0; kj<kids.length; kj++) kids[kj].style.transitionDelay = (kj * 90) + 'ms';
  }
  /* éléments à cascade générique */
  var stagger = ROOT.querySelectorAll('[data-stagger]');
  for(var si=0; si<stagger.length; si++){
    var st = stagger[si].children;
    for(var sj=0; sj<st.length; sj++) st[sj].style.transitionDelay = (sj * 80) + 'ms';
  }

  /* =========================================================
     5. COMPTEURS
     ========================================================= */
  function runCount(el){
    var to = parseFloat(el.getAttribute('data-count'));
    var dec = parseInt(el.getAttribute('data-dec') || '0', 10);
    if(reduced){ el.textContent = to.toLocaleString('fr-FR',{minimumFractionDigits:dec,maximumFractionDigits:dec}); return; }
    var dur = 1500, t0 = null;
    function step(ts){
      if(!t0) t0 = ts;
      var k = clamp((ts - t0)/dur, 0, 1);
      var e = 1 - Math.pow(2, -10 * k);
      var v = to * (k===1 ? 1 : e);
      el.textContent = v.toLocaleString('fr-FR',{minimumFractionDigits:dec,maximumFractionDigits:dec});
      if(k < 1) raf(step);
    }
    raf(step);
  }

  /* =========================================================
     6. DÉCODAGE
     ========================================================= */
  var GLYPHS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789µ∆×∑';
  function runDecode(el){
    var final = el.getAttribute('data-decode');
    if(reduced){ el.textContent = final; return; }
    var n = final.length, frame = 0, per = 3;
    el.textContent = '';
    function step(){
      var out = '', done = 0, i;
      for(i=0;i<n;i++){
        var reveal = Math.floor(frame/per) - i*0.7;
        if(final[i] === ' '){ out += ' '; done++; continue; }
        if(reveal > 4){ out += final[i]; done++; }
        else if(reveal > 0){ out += GLYPHS[Math.floor(Math.random()*GLYPHS.length)]; }
        else { out += ' '; }
      }
      el.textContent = out;
      frame++;
      if(done < n) raf(step);
      else el.textContent = final;
    }
    raf(step);
  }

  /* =========================================================
     7. TRACÉS SVG DES SCHÉMAS
     ========================================================= */
  var groups = ROOT.querySelectorAll('[data-draw-group]');
  for(var gi=0; gi<groups.length; gi++){
    var paths = groups[gi].querySelectorAll('.mr-dr');
    for(var pi=0; pi<paths.length; pi++){
      var pp = paths[pi];
      try{
        var L = pp.getTotalLength();
        pp.style.strokeDasharray = L + ' ' + L;
        pp.style.strokeDashoffset = L;
        pp.style.transitionDelay = (pi * 110) + 'ms';
      }catch(e){}
    }
    var dots = groups[gi].querySelectorAll('.mr-dot');
    for(var di=0; di<dots.length; di++) dots[di].style.transitionDelay = (500 + di*90) + 'ms';
  }

  /* =========================================================
     8. BOUTONS MAGNÉTIQUES
     ========================================================= */
  if(window.matchMedia('(hover:hover)').matches && !reduced){
    var mags = ROOT.querySelectorAll('[data-magnetic]');
    Array.prototype.forEach.call(mags, function(btn){
      var mx=0,my=0,cx=0,cy=0,active=false;
      btn.addEventListener('mousemove', function(e){
        var r = btn.getBoundingClientRect();
        mx = (e.clientX - (r.left + r.width/2)) * 0.28;
        my = (e.clientY - (r.top + r.height/2)) * 0.38;
        if(!active){ active=true; loop(); }
      });
      btn.addEventListener('mouseleave', function(){ mx=0; my=0; });
      function loop(){
        cx = lerp(cx, mx, 0.16); cy = lerp(cy, my, 0.16);
        btn.style.transform = 'translate3d('+cx.toFixed(2)+'px,'+cy.toFixed(2)+'px,0)';
        if(Math.abs(cx)<0.05 && Math.abs(cy)<0.05 && mx===0 && my===0){ btn.style.transform=''; active=false; return; }
        raf(loop);
      }
    });
  }

  /* =========================================================
     9. HALO CURSEUR
     ========================================================= */
  var lamp = ROOT.querySelector('[data-lamp]');
  if(lamp && window.matchMedia('(hover:hover) and (min-width:1025px)').matches && !reduced){
    var lx=window.innerWidth/2, ly=window.innerHeight/2, tx=lx, ty=ly, lampOn=false;
    window.addEventListener('mousemove', function(e){ tx=e.clientX; ty=e.clientY; if(!lampOn){ lampOn=true; lamp.style.opacity=1; lampLoop(); } }, {passive:true});
    function lampLoop(){
      lx = lerp(lx, tx, 0.12); ly = lerp(ly, ty, 0.12);
      lamp.style.transform = 'translate3d('+(lx).toFixed(1)+'px,'+(ly).toFixed(1)+'px,0) translate(-50%,-50%)';
      raf(lampLoop);
    }
  } else if(lamp){ lamp.remove(); }

  /* =========================================================
     10. FAQ
     ========================================================= */
  var accs = ROOT.querySelectorAll('[data-acc]');
  Array.prototype.forEach.call(accs, function(btn){
    btn.addEventListener('click', function(){
      var open = btn.getAttribute('aria-expanded') === 'true';
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      if(panel) panel.style.maxHeight = open ? '' : (panel.scrollHeight + 32) + 'px';
    });
  });

  /* =========================================================
     11. ANCRES INTERNES
     ========================================================= */
  Array.prototype.forEach.call(ROOT.querySelectorAll('a[href^="#mr-"]'), function(a){
    a.addEventListener('click', function(e){
      var t = document.getElementById(a.getAttribute('href').slice(1));
      if(!t) return;
      e.preventDefault();
      window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 70, behavior: reduced ? 'auto' : 'smooth' });
    });
  });

  /* =========================================================
     12. INIT
     ========================================================= */
  function relayout(){ buildThread(); paintThread(progC); }
  var rt;
  window.addEventListener('resize', function(){ clearTimeout(rt); rt = setTimeout(relayout, 140); }, {passive:true});
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(relayout);
  window.addEventListener('load', relayout);
  Array.prototype.forEach.call(ROOT.querySelectorAll('img'), function(im){
    if(!im.complete) im.addEventListener('load', function(){ clearTimeout(rt); rt=setTimeout(relayout,80); }, {once:true});
  });
  relayout();
  raf(tick);
  ROOT.classList.add('mr-ready');
})();
